import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  checkoutApi,
  getInvoiceMetaApi,
  getInvoicePaymentMethodsApi
} from 'src/services/oms'
import { mockCheckoutMeta, mockCheckoutResult } from 'src/services/mock'
import { NextPageContext } from 'next'
import type { CustomisationStateInReducer } from '../customisation'

interface PayInvoiceParams {
  storeOrderId: string
  customerId: string
  customerEmail: string
  customerFirstName: string
  customerLastName: string
  customerContactNumber: string
  customerCompany: string
  recipientName: string
  recipientContact: string
  billingAddressOne: string
  billingAddressTwo: string
  billingAddressState: string
  billingAddressCity: string
  billingAddressPostal: string
  billingAddressCountry: string
  stripeRequestPaymentButtonType: string
  additionalInformation: string
  paymentOption: string
  paymentOptionId: string
  paymentType: string
  subscribeToEmail: boolean
  unifiedBusinessNumber: string
  carrierType: string
  carrierNumber: string
  paymentToken: string
  redirectUrl: string
  otp: string
  version: string
}

export const getInvoiceMeta = createAsyncThunk(
  '@invoice/meta',
  async (
    {
      storeOrderId,
      hashCode,
      req
    }: {
      storeOrderId: string
      hashCode?: string
      req?: NextPageContext['req']
    },
    thunkApi
  ) => {
    try {
      const state = thunkApi.getState() as CustomisationStateInReducer
      const previewMode = state['@customisation'].data
        .previewMode as unknown as string

      if (previewMode) {
        return mockCheckoutMeta
      }
      const result = await getInvoiceMetaApi({ storeOrderId, hashCode })
      return result.data
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return thunkApi.rejectWithValue(err.response.data)
    }
  }
)

export const getInvoicePaymentMethods = createAsyncThunk(
  '@invoice/paymentMethod',
  async ({
    storeOrderId,
    req
  }: {
    storeOrderId: string
    req: NextPageContext['req']
  }) => {
    const result = await getInvoicePaymentMethodsApi({ storeOrderId })
    return result.data
  }
)

export const payInvoice = createAsyncThunk(
  '@invoice/makePayment',
  async (payload: PayInvoiceParams, thunkApi) => {
    const state = thunkApi.getState() as CustomisationStateInReducer
    const previewMode = state['@customisation'].data
      .previewMode as unknown as string
    if (previewMode) {
      return mockCheckoutResult
    }
    const result = await checkoutApi(payload)
    return result.data
  }
)
